import { render, staticRenderFns } from "./OrderViewActionEdit.vue?vue&type=template&id=97f3219e&"
import script from "./OrderViewActionEdit.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports